@app.directive 'premiumSubscriptionButtonForm', ($state, $filter)->
  restrict: 'E'
  scope: {}
  controllerAs: 'premiumSubscriptionButtonForm'
  controller: ->
    this

  bindToController: {
    content: '='
  }
  templateUrl: "/assets/templates/components/customButton/premiumSubscriptionButton/premiumSubscriptionButtonForm.html"
